var colors = {
  darkRed: '#8f0b10',
  lightBlue: '#40a9ff'
};
export default colors;